import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 Érzésre.hu - Minden jog fenntartva</p>
        <p>Főzzünk együtt érzésre!</p>
      </div>
    </footer>
  );
};

export default Footer;
